import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as moment from 'moment';
import { MatSelectChange } from '@angular/material/select';
import { CharterDAO } from '../../../../../../core/services/dao/charterDAO';
import { ContainsSubscriptions } from '../../../../../../core/services/interfaces/contains-subscriptions';
import { Subscription } from 'rxjs/Rx';
import { unsubscribeFromAll } from '../../../../../../core/pure-functions/rx-helper';
import { Charter } from 'anchor-shared/lib/model/entity/charter';

@Component({
  selector: 'app-captain-search',
  templateUrl: './captain-search.component.html',
  styleUrls: ['./captain-search.component.scss'],
})
export class CaptainSearchComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  searchParams: CaptainSearchParams = {
    charterId: undefined,
    date: undefined,
    waterBodyIds: [],
    limit: 5,
    page: 0,
  };
  selectableStates: any;
  selectedState: any;
  chosenBodies: any[] = [];
  subs: Subscription[] = [];
  charterCount: number = null;
  chartersWithRowCount: { count: number; rows: Charter[] };
  private existingSearchParams: CaptainSearchParams;

  constructor(
    private dialogRef: MatDialogRef<CaptainSearchComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private charterDao: CharterDAO,
  ) {}

  ngOnInit() {
    this.selectableStates = this.data.stateWaterBodyMappings;
    this.existingSearchParams = this.data.searchParams;
    this.initSearchParams();
    this.getChartersForSearchParams();
  }

  ngOnDestroy() {
    unsubscribeFromAll(this.subs);
  }

  emitChartersAndSearchParams() {
    this.setSearchParamsInLocalStorage();
    this.dialogRef.close({
      charters: this.chartersWithRowCount,
      searchParams: this.searchParams,
    });
  }

  waterBodyChosen(waterBodySelectionEvent: MatSelectChange) {
    let chosenBody = waterBodySelectionEvent.value;
    if (!this.searchParams.waterBodyIds.includes(chosenBody.id)) {
      this.searchParams.waterBodyIds.push(chosenBody.id);
      this.chosenBodies.push(chosenBody);
      this.getChartersForSearchParams();
    }
  }

  removeWaterBodyFromSearch(waterBodyIndex: number) {
    this.searchParams.waterBodyIds = this.searchParams.waterBodyIds.filter(
      (wbId) => wbId !== this.chosenBodies[waterBodyIndex].id,
    );
    this.chosenBodies.splice(waterBodyIndex, 1);
    this.getChartersForSearchParams();
  }

  private setSearchParamsInLocalStorage() {
    localStorage.setItem(
      'headCaptainWaterBodySearchParams',
      JSON.stringify(this.searchParams.waterBodyIds),
    );
  }

  resetFilters() {
    this.chosenBodies = [];
    this.selectedState = null;
    this.searchParams = {
      charterId: undefined,
      date: undefined,
      waterBodyIds: [],
      limit: 5,
      page: 0,
    };
    this.charterCount = null;
    this.getChartersForSearchParams();
  }

  closeDialog() {
    this.dialogRef.close(null);
  }

  getChartersForSearchParams() {
    if (this.searchParams.date) {
      this.searchParams.date = moment(this.searchParams.date)
        .startOf('day')
        .format('YYYY-MM-DD');
    }

    let charterSub = this.charterDao
      .getOpenChartersWithoutAssignedCaptains(this.searchParams)
      .subscribe((chartersWithRowCount) => {
        this.chartersWithRowCount = chartersWithRowCount;
        this.charterCount = chartersWithRowCount.count;
      });
    this.subs.push(charterSub);
  }

  private initSearchParams() {
    if (
      this.existingSearchParams &&
      this.existingSearchParams.waterBodyIds &&
      this.existingSearchParams.waterBodyIds.length
    ) {
      for (let state of this.selectableStates) {
        state.waterBodies.forEach((waterBody) => {
          if (this.existingSearchParams.waterBodyIds.includes(waterBody.id)) {
            this.chosenBodies.push(waterBody);
          }
        });
      }
      this.searchParams = { ...this.existingSearchParams };
    }
  }
}

export interface CaptainSearchParams {
  charterId?: number;
  date?: string;
  waterBodyIds?: number[];
  limit?: number;
  page?: number;
}
